module.exports = __webpack_public_path__ + "img/share_story.2732b692.png";